import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import { useTheme } from "@mui/material/styles";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

// import { paths } from 'src/routes/paths';
import { RouterLink } from "src/routes/components";

// import { _socials } from "src/_mock";
// import {
//   TwitterIcon,
//   FacebookIcon,
//   LinkedinIcon,
//   InstagramIcon,
// } from "src/assets/icons";

import Logo from "src/components/logo";

// ----------------------------------------------------------------------

const LINKS = [
  {
    headline: "Riple",
    children: [
      { name: "About us", href: "#" },
      { name: "Contact us", href: "#" },
      // { name: "FAQs", href: "#" },
    ],
  },
  {
    headline: "Legal",
    children: [
      { name: "Terms of Use", href: "/term-of-use" },
      { name: "Privacy policy", href: "/privacy-policy" },
    ],
  },
  { headline: "Contact", children: [{ name: "hello@riple.org", href: "#" }] },
];

// ----------------------------------------------------------------------

export function Footer({ layoutQuery, sx }) {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{ position: "relative", bgcolor: "background.default", ...sx }}
    >
      <Divider />

      <Container
        sx={{
          pb: 5,
          pt: 10,
          textAlign: "center",
          [theme.breakpoints.up(layoutQuery)]: { textAlign: "unset" },
        }}
      >
        <Logo />

        <Grid
          container
          sx={{
            mt: 3,
            justifyContent: "center",
            [theme.breakpoints.up(layoutQuery)]: {
              justifyContent: "space-between",
            },
          }}
        >
          <Grid {...{ xs: 12, [layoutQuery]: 3 }}>
            <Typography
              variant="body2"
              sx={{
                mx: "auto",
                maxWidth: 280,
                [theme.breakpoints.up(layoutQuery)]: { mx: "unset" },
              }}
            >
              Riple delivers bite-sized news, PR services, APIs, branded news
              platforms, and QR-enabled solutions for businesses, hotels, and
              institutions.
            </Typography>

            <Stack
              direction="row"
              sx={{
                mt: 3,
                mb: 5,
                justifyContent: "center",
                [theme.breakpoints.up(layoutQuery)]: {
                  mb: 0,
                  justifyContent: "flex-start",
                },
              }}
            >
              {/* {_socials.map((social) => (
                <IconButton key={social.label} color="inherit">
                  {social.value === "twitter" && <TwitterIcon />}
                  {social.value === "facebook" && <FacebookIcon />}
                  {social.value === "instagram" && <InstagramIcon />}
                  {social.value === "linkedin" && <LinkedinIcon />}
                </IconButton>
              ))} */}
            </Stack>
          </Grid>

          <Grid {...{ xs: 12, [layoutQuery]: 6 }}>
            <Stack
              columnGap={5}
              rowGap={5}
              sx={{
                flexDirection: "column",
                [theme.breakpoints.up(layoutQuery)]: { flexDirection: "row" },
              }}
            >
              {LINKS.map((list, idx) => (
                <Stack
                  key={list.headline}
                  spacing={2}
                  sx={{
                    width: 1,
                    alignItems: "center",
                    [theme.breakpoints.up(layoutQuery)]: {
                      alignItems: "flex-start",
                    },
                  }}
                >
                  <Typography component="div" variant="overline">
                    {list.headline}
                  </Typography>

                  {list.children.map((link) => (
                    <Link
                      key={link.name}
                      component={RouterLink}
                      href={link.href}
                      color="inherit"
                      variant="body2"
                    >
                      {link.name}
                    </Link>
                  ))}
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Typography variant="body2" sx={{ mt: 10 }}>
          © All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}

// ----------------------------------------------------------------------

export function HomeFooter({ sx }) {
  return (
    <Box
      component="footer"
      sx={{
        py: 5,
        textAlign: "center",
        position: "relative",
        bgcolor: "background.default",
        ...sx,
      }}
    >
      <Container>
        <Logo />
        <Box sx={{ mt: 1, typography: "caption" }}>
          © All rights reserved.
          <br /> made by
          <Link href="https://riple.org/"> Riple Technologies </Link>
        </Box>
      </Container>
    </Box>
  );
}
